import React, { useRef, useState } from "react";
import { flash } from "./lib";
import { downloadNode } from "./StepsB";

const Block = ({ title, children, testid }) => (
  <div className="protocol-block" data-testid={testid}>
    <div className="protocol-h">{title}</div>
    {children}
  </div>
);

const emailBody = (p) => {
  const lines = [
    "MY MANIFESTATION PROTOCOL", "",
    "WHAT I'M CREATING", ...p.desires.map((d) => `I want to create ${d.x} because I want to feel ${d.y}.`), "",
    "WHO I AM BECOMING", p.identity, ...(p.groups || []).flatMap((g) => [`${g.desire}:`, ...g.priorities.map((x) => `  - ${x}`)]), "",
    "MY FEARLESS ACTIONS", ...p.fears.map((f) => `${f.fear} > ${f.step}`),
    p.scheduled?.done ? `Scheduled: ${p.scheduled.action} on ${p.scheduled.date} at ${p.scheduled.time}` : "", "",
    "WHERE I ALREADY FEEL MAGNETIC", p.whereText, "", "HOW I CELEBRATE IT", p.howText, "",
    "The Modern Mind Manifestation Method by Amber Lyon",
  ];
  const body = lines.join("\n");
  return body.length > 1600 ? `${body.slice(0, 1600)}\n\n(trimmed for email length)` : body;
};

export const Protocol = ({ p, email, onRestart }) => {
  const ref = useRef(null);
  const [note, setNote] = useState("");
  const sched = p.scheduled?.done && p.scheduled.action?.trim() ? p.scheduled : null;

  const download = async () => {
    setNote("Creating your image...");
    await downloadNode(ref.current, "my-manifestation-protocol.png", "#fbf8f2");
    flash(setNote, "Saved to your downloads.");
  };
  const mail = () => {
    window.location.href = `mailto:${encodeURIComponent(email)}?subject=${encodeURIComponent("My Manifestation Protocol")}&body=${encodeURIComponent(emailBody(p))}`;
  };

  return (
    <section className="flow-step protocol-section" id="protocol" data-testid="protocol-section">
      <div className="container wide">
        <div className="paper-tilt">
        <div className="protocol-card paper" ref={ref} data-testid="protocol-card">
          <div className="protocol-title">Manifest</div>
          <div className="protocol-kicker">My manifestation protocol</div>

          <Block title="What I'm creating" testid="protocol-creating">
            {p.desires.map((d, i) => (
              <p key={i}>I want to create <strong>{d.x}</strong> because I want to feel <em>{d.y.trim().toLowerCase()}</em>.</p>
            ))}
          </Block>
          <Block title="Who I am becoming" testid="protocol-becoming">
            <p className="identity-line">{p.identity}</p>
            {(p.groups || []).map((g, i) => (
              <div key={i} className="protocol-group">
                <div className="protocol-desire">{g.desire}</div>
                <ol className="protocol-ol">{g.priorities.map((x, j) => <li key={j}>{x}</li>)}</ol>
              </div>
            ))}
          </Block>
          <Block title="Where I already feel magnetic" testid="protocol-appreciate">
            {p.glimmers && Object.keys(p.glimmers).length
              ? Object.entries(p.glimmers).filter(([, v]) => v.trim()).map(([y, v]) => (
                  <p key={y}><em>{y}</em>: {v}</p>
                ))
              : <p>{p.whereText}</p>}
            {p.howText && <p><strong>How I'll celebrate it:</strong> {p.howText}</p>}
          </Block>
          <Block title="My fearless actions" testid="protocol-fearless">
            {p.fears.map((f, i) => <p key={i}>{f.step}</p>)}
            {sched && (
              <p className="scheduled" data-testid="protocol-scheduled">
                {sched.action}
                <span className="sched-tag">scheduled {sched.date} {sched.time}</span>
              </p>
            )}
          </Block>
          <div className="protocol-foot">Modern Mind &middot; {new Date().toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" })}</div>
        </div>
        </div>
        <div className="btn-row justify-center" data-html2canvas-ignore="true">
          <button className="mono-btn release-btn" onClick={download} data-testid="protocol-download-btn">Download my protocol</button>
          <button className="mono-btn calendar-btn mt-4" onClick={mail} data-testid="protocol-email-btn">Email it to me</button>
          <button className="mono-btn calendar-btn mt-4" onClick={onRestart} data-testid="protocol-restart-btn">Start a new protocol</button>
          <a href="#keep-going" className="mono-btn calendar-btn mt-4 future-inline" data-testid="protocol-future-btn">Rehearse your future self</a>
        </div>
        <div className="save-note text-center" data-testid="protocol-note">{note}</div>
      </div>
    </section>
  );
};
